import Vue from "vue";
import {
  Input,
  Button,
  Loading,
  Message,
  Table,
  TableColumn,
  Menu,
  Aside,
  Container,
  Main,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Pagination,
  Dialog,
  Tabs,
  TabPane
} from "element-ui";
import "./element-variables.scss";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

locale.use(lang);

Vue.use(Input);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Menu);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Container);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Submenu);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
